export default "__VITE_ASSET__ed62ad42__"